import {createSlice} from "@reduxjs/toolkit"
import { UserDetailType } from "../user/Types";
import type { SessionPermissionAction } from "../../../utils/permissions/flattenRolePermissions";

type initialstateType = {
    loginDetail : {}[],
    loggedUserDetail: UserDetailType | null;
    custRecoverSuccessMsg : string,
    status : {
        loggedUserDetailLoading: boolean
    }
    errorInfo : {
        severity : string,
        errorMsg : string,
        open : boolean
    }
    sessionPermissionMap: Record<string, SessionPermissionAction>;
    sessionPartnerPermissionMap: Record<string, SessionPermissionAction>;
    sessionPermissionsLoading: boolean;
    sessionPermissionsLoaded: boolean;
}

var initialstate : initialstateType = {
    loginDetail : [],
    loggedUserDetail: null,
    custRecoverSuccessMsg: "",
    status : {
        loggedUserDetailLoading: false,
    }, 
    errorInfo : {
        severity : "",
        errorMsg : "",
        open : false
    },
    sessionPermissionMap: {},
    sessionPartnerPermissionMap: {},
    sessionPermissionsLoading: false,
    sessionPermissionsLoaded: false,

}

const authSlice = createSlice({
    name : "auth",
    initialState : initialstate,
    reducers : {
        setLoginDetails : (state, action) => {
            state.loginDetail = action.payload
        },
        setCustRecoverSuccessMsg: (state, action) => {
            state.custRecoverSuccessMsg = action.payload;
        },
        setLoggedUserDetail: (state, action) => {
            state.loggedUserDetail = action.payload;
        },
        setLoggedUserDetailLoading: (state, action) => {
            state.status.loggedUserDetailLoading = action.payload;
        },
        logOut : (state) => {
            state.loginDetail = [];
            state.loggedUserDetail = null;
            state.sessionPermissionMap = {};
            state.sessionPartnerPermissionMap = {};
            state.sessionPermissionsLoading = false;
            state.sessionPermissionsLoaded = false;
            localStorage.clear()
        },
        errorInfoTrigger : (state, action) => {
           state.errorInfo = action.payload
        },
        reset : (state) => {
            state.loginDetail = []
            state.loggedUserDetail = null;
            state.sessionPermissionMap = {};
            state.sessionPartnerPermissionMap = {};
            state.sessionPermissionsLoading = false;
            state.sessionPermissionsLoaded = false;
        },
        setSessionPermissionMap: (state, action: { payload: Record<string, SessionPermissionAction> }) => {
            state.sessionPermissionMap = action.payload;
        },
        setSessionPartnerPermissionMap: (state, action: { payload: Record<string, SessionPermissionAction> }) => {
            state.sessionPartnerPermissionMap = action.payload;
        },
        setSessionPermissionsLoading: (state, action: { payload: boolean }) => {
            state.sessionPermissionsLoading = action.payload;
        },
        setSessionPermissionsLoaded: (state, action: { payload: boolean }) => {
            state.sessionPermissionsLoaded = action.payload;
        },
        
    }
})

export const authReducer = authSlice.reducer;
export const authSliceAction = authSlice.actions;